import React from 'react';

export type BadgeVariant =
  | 'success'
  | 'warning'
  | 'error'
  | 'info'
  | 'default'
  | 'brand'
  | 'custom';

interface BadgeProps {
  label: string;
  variant?: BadgeVariant;
  className?: string;
  customBgColor?: string; // Add custom background color prop
  customTextColor?: string; // Add custom text color prop
}

// State colours are Tailwind's, not brand: the brand pack has no semantic success/warning/error
// palette (BRAND.md section 4). `brand` is the gold one, and it uses the tinted-fill + deep-gold-
// text pairing, because gold text on a pale ground is 2.32:1 and unreadable.
const variantStyles: Record<BadgeVariant, string> = {
  success: 'bg-green-100 text-green-800',
  warning: 'bg-orange-100 text-orange-900',
  error: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800',
  default: 'bg-gray-100 text-ink',
  brand: 'bg-primary/15 text-primary-deep ring-1 ring-inset ring-primary/40',
  custom: '', // Empty string for custom styling
};

export const Badge: React.FC<BadgeProps> = ({
  label,
  variant = 'default',
  className = '',
  customBgColor,
  customTextColor,
}) => {
  const style =
    variant === 'custom'
      ? {
          backgroundColor: customBgColor,
          color: customTextColor || '#000000',
        }
      : {};

  return (
    <span
      style={style}
      className={`px-2 py-1 text-xs font-semibold rounded inline-flex items-center
        ${variant !== 'custom' ? variantStyles[variant] : ''} ${className}`}
    >
      {label}
    </span>
  );
};

export default Badge;
